import { collection, doc, setDoc, getDoc, getDocs, deleteDoc, query, where, orderBy, Firestore } from 'firebase/firestore';

class FirebaseService {
  constructor(private db: Firestore) {}

  async getDocument(collectionName: string, docId: string) {
    const docRef = doc(this.db, collectionName, docId);
    const docSnap = await getDoc(docRef);
    return docSnap.exists() ? docSnap.data() : null;
  }

  async getDocuments(collectionName: string, conditions: any[] = [], orderByFields: any[] = []) {
    let baseQuery = collection(this.db, collectionName);

    // Apply conditions and orderBy clauses to the query
    const queryConstraints = [
      ...conditions.map(([field, operator, value]) => where(field, operator, value)),
      ...orderByFields.map(([field, direction]) => orderBy(field, direction))
    ];

    const finalQuery = query(baseQuery, ...queryConstraints);
    const snapshot = await getDocs(finalQuery);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  }

  async saveDocument(collectionName: string, docId: string, data: any) {
    const docRef = doc(this.db, collectionName, docId);
    await setDoc(docRef, data);
  }

  async deleteDocument(collectionName: string, docId: string) {
    const docRef = doc(this.db, collectionName, docId);
    await deleteDoc(docRef);
  }
}

export default FirebaseService;